// src/components/NotFound.jsx — catch-all 404 page for unknown routes.
import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../css/Feedback.css';

const NotFound = () => {
    const navigate = useNavigate();
    return (
        <div className="app-notfound qd-page">
            <div className="app-notfound-code">404</div>
            <h1>Page not found</h1>
            <p>The page you're looking for doesn't exist or has moved.</p>
            <button className="app-error-btn" onClick={() => navigate('/')}>
                Back to QDex
            </button>
        </div>
    );
};

export default NotFound;
